import { Controller } from '@hotwired/stimulus'
import { cable } from '@hotwired/turbo-rails'

export default class extends Controller {
  static values = {
    roomId: Number
  }

  async connect() {
    this.channel = await cable.subscribeTo({
      channel: 'RoomChannel',
      room_id: this.roomIdValue
    })

    this.channel.perform('mark_room_active', {
      room_id: this.roomIdValue
    })

    this.interval = setInterval(() => {
      this.channel.perform('refresh_room_presence', {
        room_id: this.roomIdValue
      })
    }, 30000)

    this.visibilityHandler = () => {
      if (document.hidden) {
        this.channel.perform('mark_room_inactive')
      } else {
        this.channel.perform('mark_room_active', {
          room_id: this.roomIdValue
        })
      }
    }

    document.addEventListener(
      'visibilitychange',
      this.visibilityHandler
    )
  }

  disconnect() {
    clearInterval(this.interval)
    document.removeEventListener('visibilitychange', this.visibilityHandler)

    if (this.channel) {
      this.channel.perform('mark_room_inactive')
    }
  }
}